import {
  createAuthContext,
  createWishlistContext,
} from '@monofront/business/contexts';
import {
  authCRUD,
  customerCRUD,
  wishlistService,
} from '@services/businessContainer';

export const { AuthProvider, useAuthentication } = createAuthContext(
  authCRUD,
  customerCRUD,
);

export const { WishlistProvider, useWishlist } = createWishlistContext(
  wishlistService,
  useAuthentication,
);
